// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lw-2","type":"styles_type__1ApZj","choices":"styles_choices__2tLXu"};